// import { BrowserStorage } from './../types/plugins/browser-storage.d';

export default defineNuxtPlugin({
  async setup() {

    const BrowserStorage = reactive({
      recentSearch: [] as any[],
      getRecentSearch: null,
      saveRecentSearch: null,
      clearSearchHistory: null,

    });

    const getRecentSearch  = () => {
      if (process.server) {
				return;
			}
			try {
				const savedRecentSearches = JSON.parse(
					localStorage.getItem('recentSearch') || '[]'
				);
				BrowserStorage.recentSearch = savedRecentSearches;
			} catch (error) {
				throw error;
			}
    };

    const saveRecentSearch = (id: any) => {
			if (!id) return;
			if (BrowserStorage.recentSearch && BrowserStorage.recentSearch.length === 0) {
				BrowserStorage.recentSearch.push(id);
			} else {

				const index = BrowserStorage.recentSearch?.findIndex(e => e === id)
				if (index > -1) {
					BrowserStorage.recentSearch.splice(index, 1);
				}
				BrowserStorage.recentSearch.push(id)
				if (BrowserStorage.recentSearch.length > 5) {
					BrowserStorage.recentSearch.splice(0, 1);
				}
			}
			localStorage.setItem('recentSearch', JSON.stringify(BrowserStorage.recentSearch));
		};

		const clearSearchHistory = () => {
			BrowserStorage.recentSearch = [];
			localStorage.setItem('recentSearch', JSON.stringify(BrowserStorage.recentSearch));
		};


    BrowserStorage.getRecentSearch = getRecentSearch;
    BrowserStorage.saveRecentSearch = saveRecentSearch;
    BrowserStorage.clearSearchHistory = clearSearchHistory;
	getRecentSearch();
    return {
      provide: {
        BrowserStorage
      }
    }
  }
})
